/**
 * iter326 — Kullanıcı Kontrol Paneli
 *
 * Admin Kontrol Paneli ile BİREBİR aynı Dashboard componentini kullanır.
 * Tek fark: scope="user_control" → layout prefs shared endpoint'ten gelir,
 * düzenleme yetkisi backend tarafından enforce edilir.
 *
 * Tasarım hedefi: 2 ayrı dashboard mimarisi değil, 1 canonical dashboard +
 * scope parametresi. Veri/hesaplama/widget registry ortak.
 */
import React from "react";
import Dashboard from "@/pages/Dashboard";

export default function UserControlDashboard() {
  return <Dashboard scope="user_control" />;
}
